// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__25ZXX","header":"Messages_header__HVQby"};